(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxWizardView', {
		bindings: {
			wizard: '=',
			nonVisualTemplate: '=',
			dataModel: '=model',
			wizardHeaderText: '=',
			isLazy: '<?',
			dirty: '=?',
			mergeDisabled: '<',
		},
		controller: MxWizardViewCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/wizard/mx-wizard-view.html',
	});

	function MxWizardViewCtrl() {
		var vm = this;

		vm.$onInit = function () {
			vm.warningMessage = '';
			vm.showWarning = false;

			vm.nonVisualView = {
				Type: mx.SolutionBuilderAgent.ContentWidgetViewType.NonVisual,
				Template: vm.nonVisualTemplate,
			};

			// TODO: temp hack
			vm.wizardToBeValidated = vm.nonVisualView.Template.indexOf('<mx-validate-wizard ') !== -1;

			vm.serviceContextInfo = {
				widgetId: vm.widgetId,
				viewName: vm.wizard.currentPage?.key,
			};
		};

		Object.defineProperty(vm, 'dirty', {
			get: function () {
				return vm.wizard.dirty;
			},
			set: function (dirty) {
				vm.wizard.dirty = dirty;
			},
		});

		Object.defineProperty(vm, 'mergeDisabled', {
			get: function () {
				return vm.wizard.mergeDisabled;
			},
			set: function (mergeDisabled) {
				vm.wizard.mergeDisabled = mergeDisabled;
			},
		});

		return vm;
	}
})();
